/**
 * 业务错误码
 */
export enum ServiceErrorCode {
  //违禁词
  BANNED_WORDS = '900000',
}

/**
 * 智能创作版本
 */
export const WorkDebuggerVersion = 0.353;
